import dsaImg from '../../../img/renaissance-new/TechStack/DSA- Active.svg';
import lldHldImg from '../../../img/renaissance-new/TechStack/LLD-HLD- Active.svg';
import fullStackImg from '../../../img/renaissance-new/TechStack/Full-Stack- Active.svg';
import agenticAiImg from '../../../img/renaissance-new/TechStack/Agentic AI IMG.svg';

export const TECH_STACK_CARDS = [
  {
    id: 'dsa',
    badge: 'MASTER CODING INTERVIEWS',
    heading: 'Data Structures & Algorithms',
    image: dsaImg,
    imageWidth: 282,
    imageHeight: 233,
  },
  {
    id: 'systemDesign',
    badge: 'DESIGN SCALABLE SYSTEMS',
    heading: 'Low-Level & High-Level Design',
    image: lldHldImg,
    imageWidth: 282,
    imageHeight: 212,
  },
  {
    id: 'fullStack',
    badge: 'BUILD REAL WORLD APPLICATIONS',
    heading: 'Full-Stack & Backend Development',
    image: fullStackImg,
    imageWidth: 282,
    imageHeight: 260,
  },
  {
    id: 'ai',
    badge: 'BUILD INTELLIGENT SYSTEMS',
    heading: 'LLMs & Agentic AI',
    image: agenticAiImg,
    imageWidth: 319,
    imageHeight: 307,
    imageAlign: 'left',
    imageScale: 1.15,
    imageOffsetY: 20,
  },
];
